import { useContext } from 'react';
import { ProductContext, ProductContextType } from './ProductContextProvider';

/**
 * Hook for surfacing product details.
 * Should be used within a ProductContextProvider component.
 *
 * @returns The product context object containing product information
 *
 * @example
 * ```tsx
 * const { name } = useProductContext();
 * ```
 */
export function useProductContext(): ProductContextType {
  return useContext(ProductContext);
}
